/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface NotifyWalletConnectRequest
 */
export interface NotifyWalletConnectRequest {
  /**
   *
   * @type {string}
   * @memberof NotifyWalletConnectRequest
   */
  deviceId?: string
  /**
   *
   * @type {string}
   * @memberof NotifyWalletConnectRequest
   */
  walletAddress?: string
}

export function NotifyWalletConnectRequestFromJSON(json: any): NotifyWalletConnectRequest {
  return NotifyWalletConnectRequestFromJSONTyped(json, false)
}

export function NotifyWalletConnectRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NotifyWalletConnectRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    deviceId: !exists(json, 'deviceId') ? undefined : json['deviceId'],
    walletAddress: !exists(json, 'walletAddress') ? undefined : json['walletAddress'],
  }
}

export function NotifyWalletConnectRequestToJSON(value?: NotifyWalletConnectRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    deviceId: value.deviceId,
    walletAddress: value.walletAddress,
  }
}
